import { render, staticRenderFns } from "./ProductTechnologies.vue?vue&type=template&id=0e490424&"
import script from "./ProductTechnologies.vue?vue&type=script&lang=js&"
export * from "./ProductTechnologies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports